export const Slideshow = () => {
  const slides = [
    { src: "./bar1.jpg", caption: "" },
    { src: "./2024-PJsPOKER-4.jpg", caption: "Join us for poker!" },
    { src: "./vodkaRedbull.jpg", caption: "" },
        { src: "./busybar1.jpg", caption: "Live Music!" },
  ];

  return (
    <div
      id="carouselExampleCaptions"
      className="carousel slide slideshow"
      data-bs-ride="carousel"
    >
      <div className="carousel-indicators">
        {slides.map((slide, index) => (
          <button
            key={index}
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to={index}
            className={index === 0 ? "active" : ""}
            aria-current={index === 0 ? "true" : undefined}
            aria-label={`Slide ${index + 1}`}
          ></button>
        ))}
      </div>

      <div className="carousel-inner">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-item ${index === 0 ? "active" : ""}`}
              style={{ backgroundImage: `url(${slide.src})` }}
          >
            
            <div className="carousel-caption d-none d-md-block">
              <h5>{slide.caption}</h5>
            </div>
          </div>
        ))}
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>

      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};